import { getLatLng, geocodeByAddress } from 'react-places-autocomplete';


const ADDRESS_COMPONENT_MAP = {
  country: { target: 'country', source: 'long_name' },
  postal_code: { target: 'postCode', source: 'short_name' },
  administrative_area_level_1: { target: 'state', source: 'short_name' },
  street_number: { target: 'streetNumber', source: 'short_name' },
  route: { target: 'street', source: 'long_name' },
  locality: { target: 'citySuburb', source: 'short_name' }
};


export async function getCoordinates(address, isFormatedAddress = true) {
  if (!isFormatedAddress) {
    return getLatLng(address);
  }
  const { street, citySuburb, state, country } = address;

  if (!street || !citySuburb || !state || !country) {
    return Promise.resolve(null);
  }

  const addressStr = `${street}, ${citySuburb} ${state}, ${country}`;

  const results = await geocodeByAddress(addressStr);
  return getLatLng(results[0]);
}

/**
 * Trim a value if defined
 *
 * @param {string|undefined} value
 *
 * @return {string}
 */
function getAddressValue(value) {
  return value ? value.trim() : '';
}

/**
 * Builds a full address object from a partial address
 *
 * @param {Address} address
 *
 * @return {Address}
 */
// $FlowFixMe
export function getFullAddressFromPartial(address) {
  return {
    country: getAddressValue(address.country),
    unit: getAddressValue(address.unit),
    street: getAddressValue(address.street),
    citySuburb: getAddressValue(address.citySuburb),
    state: getAddressValue(address.state),
    postCode: getAddressValue(address.postCode),
    coordinates: address.coordinates || null
  };
}

/**
 * Builds an address object from a single line address string.
 *
 * eg. 123 Foobar Street, MySuburb NSW, 2000
 *
 * @param {Object[]} addressComponents
 *
 * @return {Address}
 */
export function buildAddressStateFromRes(addressComponents) {
  const address = addressComponents.reduce((state, component) => {
    const mappedType = component.types.find((type) => ADDRESS_COMPONENT_MAP[type]);
    const mapped = ADDRESS_COMPONENT_MAP[mappedType];

    if (!mapped) {return state;}

    const { target, source } = mapped;

    return { ...state, [target]: component[source] };
  }, {});

  const { street, streetNumber, ...otherAddressFields } = address;

  return {
    street: `${streetNumber || ''}${streetNumber && street ? ' ' : ''}${street || ''}`,
    ...otherAddressFields
  };
}

/**
 * Checks whether an address object is valid by looking at required fields.
 * In future will need to be more advanced and actually check whether an
 * address is valid.
 *
 * @param {Address} address
 *
 * @return {boolean}
 */
// $FlowFixMe
export function isValidAddress(address) {
  return Boolean(address.street && address.country && address.citySuburb &&
  address.state && address.postCode);
}